import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link as RouterLink } from "react-router-dom";
import { ReactNode } from "react";

export type AppBreadcrumbItem = {
  label: ReactNode;
  to?: string;
};

export type AppBreadcrumbsProps = {
  items: AppBreadcrumbItem[];
  className?: string;
};

export function AppBreadcrumbs({ items, className }: AppBreadcrumbsProps) {
  if (!items.length) return null;

  return (
    <Breadcrumbs
      className={className}
      separator={<NavigateNextIcon fontSize="small" sx={{ color: "text.secondary" }} />}
      aria-label="Breadcrumb"
      sx={{
        mb: 1.5,
        "& .MuiBreadcrumbs-ol": { flexWrap: "wrap" },
      }}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        if (!isLast && item.to) {
          return (
            <Link
              key={`${item.to}-${index}`}
              component={RouterLink}
              to={item.to}
              underline="hover"
              color="text.secondary"
              variant="body2"
              sx={{ fontWeight: 500 }}
            >
              {item.label}
            </Link>
          );
        }
        return (
          <Typography
            key={`current-${index}`}
            variant="body2"
            color="text.primary"
            sx={{ fontWeight: 600 }}
          >
            {item.label}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
}

export default AppBreadcrumbs;
